module.exports = __webpack_public_path__ + "img/logo-top@2x.ff822627.png";